import { Heading as ThemeHeading, ThemeUIStyleObject } from "theme-ui";
import React, { ReactNode } from "react";

type Props = {
  children: ReactNode;
  sx?: ThemeUIStyleObject | undefined;
  as?: React.ElementType;
  variant?: "h1" | "h2" | "h3" | "h4" | "h5";
  htmlFor?: string;
  id?: string;
  name?: string;
};

export const Heading: React.FC<Props> = ({
  children,
  sx,
  as,
  variant,
  htmlFor,
  id,
  name,
}) => {
  return (
    <ThemeHeading
      sx={sx}
      as={as}
      variant={variant}
      //@ts-ignore
      htmlFor={htmlFor}
      id={id}
      name={name}
    >
      {children}
    </ThemeHeading>
  );
};
